export default __webpack_public_path__ + "static/media/diamond-color-table@3x.38a880f2.png";